export { Step6Preferences as default } from './RemainingSteps';